import { forwardRef } from 'react';

import { QueryKeyEnum } from 'core/global.enum';
import { useQuery } from 'hooks/useQuery/useQuery';
import { fetchOrganizations, fetchOrganizationsForUser } from 'api/organizations/organizations';

import { TreeMultiSelect } from './treeMultiSelect/TreeMultiSelect';
import { TreeSingleSelect } from './treeSingleSelect/TreeSingleSelect';
import { OrganizationsTreeSelectProps } from './OrganizationsTreeSelect.types';

export const OrganizationsTreeSelect = forwardRef<HTMLInputElement, OrganizationsTreeSelectProps>((props, ref) => {
  const { useFilteredData = true, userId, ...restProps } = props;

  // Use filtered data by default, or unfiltered when explicitly requested
  const queryFn = useFilteredData ? () => fetchOrganizationsForUser(userId) : fetchOrganizations;
  const queryKey = useFilteredData ? [QueryKeyEnum.ORGANIZATIONS_FOR_USER, userId] : [QueryKeyEnum.ORGANIZATIONS];

  const { data: organizationsResponse } = useQuery(queryKey, queryFn);

  const organizations = organizationsResponse || [];

  return restProps.multiple ? (
    <TreeMultiSelect ref={ref} {...restProps} options={organizations} />
  ) : (
    <TreeSingleSelect ref={ref} {...restProps} options={organizations} />
  );
});
